/* tslint:disable */
const de = {
    validation: {
        validation_required: 'Feld {key} muss ausgefüllt werden',
        validation_string: 'Feld {key} muss aus Zeichen bestehen',
        validation_int: 'Feld {key} muss eine Zahl sein',
        validation_date: 'Feld {key} muss ein Datum sein',
        fields: {
            insight: 'Frage',
            todo: 'Zu Tun',
            responsible: 'Zuständige Person',
            contacttill: 'Termin',
            topics: 'Gewerke',
        },
    },
    errors: {
        validation: {
            nameOrTenant: "Entweder Firma oder Vor-/Nachname eingeben",
            title: 'Bitte einen Titel eingeben',
            description: 'Bitte eine Beschreibung eingeben',
            dynamic_field: 'Bitte einen titel eingeben',
            name: 'Bitte einen Namen eingeben',
            email: 'Bitte eine gültige Email-Adresse eingeben',
            emailTaken: 'Diese E-Mail-Adresse wird schon verwendet',
            password: 'Bitte ein gültiges Passwort eingeben',
            passwordIsIncorrect: 'Das aktuell eingegebene Passwort ist falsch',
            currentPassword: 'Bitte das aktuelle Passwort eingeben',
            shortPassword: 'Das Passwort muss mindestens 8 Zeichen lang sein',
            firstName: 'Bitte den Vornamen eingeben',
            lastName: 'Bitte den Nachnamen eingeben',
            shortFirstNameOrLastName: 'Der Vorname / Nachname muss mindestens zwei Zeichen lang sein',
            bkp: 'Bitte eine Gewerk Nummer eingeben (Schweiz: BKP)',
            abbreviation: 'Bitte eine Abkürzung eingeben',
            order: 'Bitte die Sortierung eingeben',
            lesson: 'Bitte geben Sie eine Lehre ein',
            phase: 'Bitte eine Phase auswählen',
            pmphase: 'Bitte eine Projektmanagement Phase auswählen',
            trade: 'Bitte ein Gewerk auswählen',
            topic: 'Bitte ein Thema auswählen',
            subphase: 'Bitte eine Subphase auswählen',
            team: 'Bitte die weiteren Teammitglieder auswählen',
            verificationCode: 'Bitte den Bestätigungscode eingeben',
            duplicateTitle: 'Dieser Projektname wird in der Firma schon verwendet',
            problem: 'Bitte eine Herausforderung eingeben',
            solution: 'Bitte eine Lösung eingeben',
            topicAndInsightNeeded: 'Es muss zwingend eine neue Frage formuliert werden und ein Themenbereich ausgewählt werden',
            address: 'Bitte eine Adresse eingeben',
            postcode: 'Bitte eine PLZ eingeben',
            city: 'Bitte eine Stadt eingeben',
            country: 'Bitte ein Land eingeben',
            useNumericValue: 'Muss zwingend eine Zahl sein',
            phone: 'Bitte ein Telefonnummer eingeben',
        },
        server: {
            invalidVerificationCode: 'Der Bestätigungscode ist nicht gültig!',
            invalidToken: 'Ungültiges Token',
            invalidFileType: 'There was an error while uploading the image.\nit could probably be caused by your connection, or invalid file extension.\nThe image must be a file of type: jpeg, png, jpg, gif, svg.',
            failedToLoadCalendar: 'Kalenderdaten konnten nicht geladen werden. Bitte versuchen Sie es später noch einmal.',
        },
        no_entries_found: 'Keine Einträge gefunden',
    },
    keywords: {
        tenant: 'Firma',
        notes: 'Notizen',
        todo: 'Zu tun',
        checked_by_user: 'Geprüft von',
        needscheck: 'Prüfen?',
        check: 'Prüfen',
        error: 'Error',
        worksheetAbbr: 'AB',
        IC: 'PD',
        CK: 'PR',
        yes: 'Ja',
        no: 'Nein',
        and: 'und',
        or: 'oder',
        show: 'Anzeigen',
        empty: 'leere',
        select: 'Wählen',
        save: 'Speichern',
        update: 'Update',
        remove: 'Löschen',
        delete: 'Löschen',
        enable: 'Aktivieren',
        enabled: 'Aktiviert',
        disable: 'Deaktivieren',
        disabled: 'Deaktiviert',
        clear: 'Auswahl löschen',
        back: 'Zurück',
        cancel: 'Abbrechen',
        close: 'Schliessen',
        logout: 'Abmelden',
        login: 'Anmelden',
        register: 'Registrieren',
        title: 'Titel',
        account: 'Benutzerkonto',
        myAccount: 'Mein Konto',
        notification: 'Benachrichtigung | Benachrichtigungen',
        subscription: 'Abo',
        settings: 'Einstellungen',
        privacy: 'Privatsphäre',
        email: 'E-Mail',
        password: 'Passwort',
        new: 'Neue',
        newProject: 'Neues Projekt',
        editProject: 'Projekt editieren',
        deleteProject: 'Projekt löschen',
        description: 'Beschrieb',
        firstname: 'Vorname',
        lastname: 'Nachname',
        at: 'bei',
        actions: 'Aktionen',
        creator: 'Ersteller',
        search: 'Suche',
        send: 'Senden',
        confirm: 'Bestätigen',
        edit: 'Editieren',
        private: 'Privat',
        users: 'Benutzer',
        phone: 'Telefon',
        add: 'Hinzufügen',
        address: 'Adresse',
        additionalAddress: 'Zusätzliche Adresse',
        postcode: 'PLZ',
        place: 'Stadt',
        country: 'Land',
        order: 'Sortierung',
        abbreviation: 'Abkürzung',
        name: 'Name',
        income: 'Einkommen',
        perMonth: 'Per Monat',
        perYear: 'Per Jahr',
        calendar: 'Kalender',
        copy: 'Kopieren',
        copied: 'Kopiert',
        all: 'Alle',
        question: 'Frage | Fragen',
        cloning: 'Klonen',
        knowledge: 'Wissen',
        project: 'Projekt | Projekte',
        worksheet: 'Arbeitsblatt',
        worksheets: 'Arbeitsblätter',
        trade: 'Gewerk | Gewerke',
        topic: 'Themenbereich | Themenbereiche',
        tradesTopics: 'Gewerke Themenbereiche',
        phasesforTrades: 'Phasen für Gewerke',
        phase: 'Phase',
        phases: 'Phasen',
        tradesPhases: 'Gewerke Phasen',
        subPhase: 'Subphase',
        projectManagement: 'Projektmanagement',
        experience: 'Erfahrung',
        experiences: 'Erfahrungen',
        lesson: 'Lehre | Lehren',
        problem: 'Herausforderung',
        possibleSolution: 'Mögliche Fragestellung',
        lessonsFor: 'Lehren zu',
        responsible: 'Verantwortlich',
        reports: 'Zu Tun',
        company: 'Firma | Firmen',
        accepting: 'Akzeptieren',
        contacttill: 'Termin',
        solution: 'Notizen',
        checked: 'Geprüft',
        checkedBy: 'Geprüft durch',
        contactEmail: 'Kontakt E-Mail',
        allPhases: 'Alle Phasen',
        appliedLessons: 'Angewandte Lehren',
        teamMembers: 'Teammitglieder',
        concept: 'Globales Thema | Globale Themen',
        pmConcept: 'Globale Sub Phase | Globale Sub Phasen',
        conceptTitle: 'Globales Thema Titel',
        done: 'Erledigt',
        print: 'Drucken',
        weekly: 'Wöchentlich',
        biweekly: 'Zweiwöchentlich',
        monthly: 'Monatlich',
        quarterly: 'Quartalsweise',
        inspectionCheckList: 'Prüfdokument',
        tag: 'Tag | Tags',
        default: 'Standard',
        feature: 'Feature | Features',
        filteringSetting: 'Filtereinstellung',
        filter: 'Filtern',
        allTags: 'Alle Tags',
        allPMSubPhases: 'Alle Subphasen',
        reset: 'Zurücksetzen',
        newTag: 'Neuer Tag',
        structure: 'Struktur | Strukturen',
        newRisk: 'Neuer Risk',
        risk: 'Risk',
        color: 'Farbe',
        noColor: 'Keine Farbe',
        newDynamicField: 'Neues Attribut',
        dynamicField: 'Attribut | Attribute',
        dynamicFieldInWorksheet: 'Dynamisches Feld in Arbeitsblättern',
        dynamicFieldName: 'Attribut Name',
        msIntegration: 'Microsoft Teams And Planner',
        updateDynamicField: 'Attribut aktualisieren',
        export: 'Export',
        moreInfo: 'Mehr Info',
        insight: 'Frage',
        integration: 'Integration | Integrationen',
        maximize: 'Maximieren',
        disconnect: 'Trennen',
        connect: 'Verbinden',
        tab: 'Reiter',
        include: 'Enthalten',
        finish: 'Beenden',
        value: 'Gewichtung',
        cost: 'Kosten (CHF)',
        probability: 'Wahrscheinlichkeit (%)',
        impact: 'Auswirkung (CHF)',
    },
    print: {
        trade: 'Gewerk | Gewerke',
        phase: 'Phase',
        todo: 'Zu tun',
        insight: 'Frage',
        solution: 'Notizen',
        responsible: 'Verantwortlich',
        contacttill: 'Termin',
        done: 'Erledigt',
        needscheck: 'Prüfen?',
        checked: 'Geprüft',
        checked_by_user: 'Geprüft von',
        cost: 'Kosten (CHF)<br>(K)',
        probability: 'Wahrscheinlichkeit (%)<br>(W)',
        impact: 'Auswirkung (CHF)<br>(R/{divider}) x K x W',
    },
    labels: {
        inheritedProject: 'Geerbtes Project',
        parentLesson: 'Übergeordnete Lehre',
        noParentLessons: 'Keine Lehren verfügbar',
        msTeamsAndPlanner: 'Microsoft Teams und Planner (Nur Gewerke und Projektmanagement)',
        projectOnly: 'Sichtbar nur für dich und andere Mitglieder im Projekt',
        myLessons: 'Meine Lehren anzeigen',
        projectManagementPhases: 'Projektmanagement Phasen',
        pMPhase: 'PM Phase | PM Phasen',
        otherTeamMembers: 'Andere AppEx Benutzer',
        externalTeamMembers: 'Externe Teammitglieder (ohne AppEx Lizenz)',
        msUsers: 'Microsoft Benutzer',
        newWorksheet: 'Neues Arbeitsblatt',
        updateWorksheet: 'Arbeitsblatt bearbeiten',
        lessonFor: 'Lehre für',
        addNewLesson: 'Neue Lehre hinzufügen',
        loginOut: 'Abmelden',
        passwordForgotten: 'Passwort vergessen?',
        newKnowledge: 'Neues Wissen',
        notifications: 'Mitteilungen',
        youAreJoining: 'Sie treten',
        newProject: 'Neues Projekt',
        updateProject: 'Projekt aktualisieren',
        newTopic: 'Neuer Themenbereich',
        updateTopic: 'Themenbereich aktualisieren',
        newTrade: 'Neue Gewerke',
        updateTrade: 'Gewerk aktualisieren',
        newPhase: 'Neue Phase',
        updatePhase: 'Phase aktualisieren',
        newSubPhase: 'Neue Subphase',
        updateSubPhase: 'Subphase aktualisieren',
        updateAt: 'Aktualisiert am',
        changedBy: 'Geändert von',
        addNewQuestion: 'Neue Frage hinzufügen',
        searchInLessons: 'In Lehren Suchen',
        passwordRecovery: 'Passwort Wiederherstellung',
        resetPassword: 'Passwort zurücksetzen',
        changePassword: 'Passwort ändern',
        verificationCode: 'Bestätigungscode',
        ResendVerificationEmail: 'Bestätigungsmail erneut senden',
        privateLessons: 'Eigene Lehren',
        FilterSubphasesAndLessons: 'Subphasen und Lehren filtern',
        filterResolved: 'Abgeschlossene Aktivitäten anzeigen',
        showEverything: 'Alles anzeigen',
        mandatoryLesson: 'Muss diese Lehre in Arbeitsblättern immer gewählt werden?',
        lessonAsQuestion: 'Lehre als Frage formuliert',
        createALesson: 'Lehre erstellen',
        selectAll: 'Alle wählen',
        createWorksheet: 'Arbeitsblatt erstellen',
        newPrivateLessonFor: 'Neue private Lehre für',
        newLesson: 'Neue Lehre',
        editLesson: 'Lehre bearbeiten',
        memberSince: 'Mitglied seit',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        confirmEmail: 'Bestätigung-Email',
        editAccount: 'Konto bearbeiten',
        calendarTutorial: 'Wie Sie Ihren Kalender abonnieren',
        calendarTutorialOutlook: 'Outlook',
        calendarTutorialOutlookInstructions: 'Gehen Sie in Outlook zum Kalender, wählen Sie "Kalender hinzufügen" und dann "Aus dem Internet". Fügen Sie den kopierten Link dort ein.',
        calendarTutorialGoogle: 'Google Kalender',
        calendarTutorialGoogleInstructions: 'Klicken Sie im Google Kalender auf das "+" neben "Weitere Kalender" und wählen Sie "Per URL". Fügen Sie den kopierten Link dort ein.',
        calendarTutorialApple: 'Apple Kalender',
        calendarTutorialAppleInstructions: 'Gehen Sie im Apple Kalender auf "Ablage" > "Neues Kalenderabonnement...". Fügen Sie den kopierten Link dort ein.',
        calendarDescription: 'Hier finden Sie Ihre persönlichen Kalender-Feeds für Ihre Aufgaben.',
        calendarLanguageSelection: 'Kalender-Link in einer anderen Sprache',
        accountDetails: 'Kontodetails',
        noLessons: 'Keine Lehren',
        noLessonsInThisWorksheet: 'Es wurden noch keine Lehren in diesem Arbeitsblatt ausgewählt.',
        noLessonsToCheck: 'Keine Fragen zum Prüfen',
        noLessonsHaveBeenSelectedToCheck: 'Es wurden keine Fragen zur Prüfung ausgewählt',
        welcomeToAppex: 'Willkommen bei Appex',
        howDoesAppexWork: 'Wie funktioniert Appex?',
        insightPlaceholder: 'Zu beantwortende Frage',
        actionNeeded: 'Besteht Handlungsbedarf?',
        needsCheck: 'Prüfen?',
        noActionNeededTitle: 'Kein Handlungsbedarf',
        noActionNeededBody: 'Im Moment gibt es keinen Handlungsbedarf.',
        projectSpecificQuestions: 'Projekt-spezifische Fragen',
        newQuestion: 'Neue Frage',
        enterDate: 'Bitte ein Datum auswählen',
        projectSpecificLesson: 'Neue Frage für dieses Projekt (wird zu einer projekt-spezifischen Lehre)',
        projectSpecificQuestion: 'Neue Frage für dieses Projekt',
        updateProjectSpecificQuestion: 'Update project-specific question',
        noLessonCreatedTitle: 'Keine Lehren erstellt',
        noLessonCreatedBody: 'Bitte zuerst eine Lehre hinzufügen',
        newCompany: 'Neue Firma erstellen',
        updateCompany: 'Firma aktualisieren',
        amountOfLessons: 'Anzahl Lehren',
        sendInvitation: 'Einladung senden',
        cloneData: 'Daten klonen',
        clonedData: 'Daten geklont',
        addNewPrivateLesson: 'Neue private Lehre hinzufügen',
        editWorksheet: 'Arbeitsblatt ergänzen',
        enableSynchronisation: 'Soll die Synchronisierung eingerichtet werden?',
        showEmptyTopics: 'Leere Themenbereiche anzeigen',
        showEmptySubphases: 'Leere Subphasen anzeigen',
        showEmptyTrades: 'Leere Gewerke anzeigen',
        assignAllDataToUser: 'Ordne alle Daten zu',
        deleteAllData: 'Löschen alle Daten',
        promoteToAdmin: 'In Administrator umwandeln',
        demoteToUser: 'In User umwandeln',
        displayColumns: 'Spalten anzeigen',
        receiveEmailNotifications: 'E-Mail Benachrichtigungen zur Erfassung von neuen Herausforderungen erhalten',
        lastOnline: 'Zuletzt Online',
        phaseDescription: 'Um was geht es in dieser Phase?',
        orderExplanation: 'Sortierung (z.B Nummer 1 - 100)',
        lessonLink: 'Link',
        lessonSolution: 'Lösung',
        moreInformation: 'Mehr Informationen',
        tooltips: {
            hbButton: 'Arbeitsblatt anzeigen',
            prButton: 'Prüfdokument anzeigen',
            newWorksheetFor: 'Neues Arbeitsblatt für {0} erstellen',
        },
        featureDynamicTab: 'Enable x tab',
        newTag: 'Neues Tag erstellen',
        updateTag: 'Tag aktualisieren',
        saveProjectToAddExternalTeamMember: 'Das Projekt muss zuerst gespeichert werden',
        addExternalTeamMember: ' Externe Teammitglieder hinzufügen',
        manageExternalTeamMember: 'Externe Teammitglieder verwalten',
        personalTasks: 'Persönliche Aufgaben',
        openTasks: 'Offene Aufgaben',
        doneTasks: 'Erledigte Aufgaben',
        allTasks: 'Alle Aufgaben',
        nonCheckedChecks: 'Nicht Geprüfte',
        checkedChecks: 'Geprüfte',
        allNeedChecks: 'Zu Prüfen',
        allChecks: 'Alle',
        sendEmail: 'E-Mail senden',
        uploadLogo: 'Logo Hochladen',
        selectLogo: 'Logo Wählen',
        selectLogoCrop: 'Selektion Wählen',
        deleteLogo: 'Logo löschen',
        addToKnowledgeBase: 'Für Wissensdatenbank vorschlagen',
        irreversibleAction: 'Das ist eine <span class="has-text-weight-semibold is-uppercase has-text-danger">irreversible Aktion!</span>',
        editInKnowledgeTab: 'Kann nur in Wissen bearbeitet werden',
        showUnread: 'Nur ungelesene Mitteilungen anzeigen',
        markAsRead: 'Als gelesen markieren',
        markAllAsRead: 'Alles als gelesen markieren',
        loadMore: 'Mehr laden',
        noUnreadLeft: 'Keine ungelesenen Mitteilungen mehr',
        tabTitle: 'Reiter titel',
        lessonTitle: 'Lektion titel',
        processTitle: 'Prozess titel',
        subProcessTitle: 'Sub Prozess titel',
        dynamicTab: 'Dynamischer Reiter',
        createdBy: 'Erstellt von',
        createdAt: 'Erstellt am',
        byParentProject: "Von übergeordnetem Projekt übernommen"
    },
    placeholder: {
        projectTitle: 'Projektname',
        projectDescription: 'Projektbeschreibung',
        teamMember: 'Wähle die weiteren Teammitglieder aus',
        selectExternalTeamMember: 'Wählen die externen Teammitglieder aus',
        selectAUser: 'Wähle eine Benutzer',
        selectAnAction: 'Wählen Sie eine Aktion aus',
        selectPhase: 'Wähle die Phasen',
        selectTrade: 'Wähle das Gewerk',
        selectProcess: 'Wähle den %{companyProcessName}',
        selectPMPhase: 'Wähle die Projektmanagement Phasen',
        selectSubPhase: 'Wähle die Subphase',
        selectXProcess: 'Prozess auswählen',
        selectTopic: 'Wähle den Themenbereich',
        selectProject: 'Wähle das Projekt',
        selectResponsible: 'Bitte jemand verantwortlich machen',
        selectTag: 'Wähle die Tags aus',
        msUsers: 'Select Microsoft Users',
        newPassword: 'Neues Passwort',
        newLessonPlaceholder: ' • Ist es ein Problem mit Kosten- oder Terminfolgen?\n\
 • Gibt es diese Lehre schon in der Wissensdatenbank?\n\
 • Ist es ein allgemeines (Projektmanagement) oder ein Gewerk-spezifisches Thema? Welches Gewerk ist betroffen?\n\
 • In welcher(n) Phase(n) muss etwas unternommen werden um das Problem zu verhindern?\n\
 • Welche Frage muss gestellt werden, damit man auf das Problem aufmerksam wird?\n\
 • Qualitätssicherung: Ist diese Frage für eine andere Person in dieser Phase verständlich?',
        newLessonTransferPlaceholder: ' • Ist es ein Problem mit Kosten- oder Terminfolgen?\n\
 • Ist es ein allgemeines (Projektmanagement) oder ein Gewerk-spezifisches Thema? Welches Gewerk ist betroffen?\n\
 • In welcher(n) Phase(n) muss etwas unternommen werden um das Problem zu verhindern?\n\
 • Welche Frage muss gestellt werden, damit man auf das Problem aufmerksam wird?\n\
 • Qualitätssicherung: Ist diese Frage für eine andere Person in dieser Phase verständlich?',
        chooseSubphase: 'Subphase auswählen',
        companyDescription: 'Bitte eine kurze Beschreibung der Firma eingeben',
        lessonLink: 'Beispiel: https://www.example.com/',
        lessonSolution: 'Haben sie eine Lösung?',
        selectParentLesson: 'Soll diese Lehre einer bestehenden Frage untergeordnet werden? Falls ja, Frage auswählen',
    },
    messages: {
        logOutFirst: 'Du musst dich zuerst abmelden',
        passwordRecoveryEmailHasBeenSent: 'Passwort Wiederherstellung E-Mail wurde gesendet',
        passwordChangedSuccessfully: 'Das Passwort wurde erfolgreich geändert',
        AnErrorHasOccurredPleaseTryAgain: 'Ein Fehler ist aufgetreten, bitte erneut versuchen!',
        RecoveryEmailIsOnlyValidFor3Hours: 'Passwort Wiederherstellung E-Mail ist nur für 3 Stunden gültig!',
        thankYouEmailConfirmed: 'Vielen Dank, die E-Mail-Adresse wurde bestätigt!',
        youHaveSuccessfullyLoggedIn: 'Erfolgreich angemeldet!',
        noChangesDetected: 'Keine Änderungen festgestellt!',
        changesSavedSuccessfully: 'Änderungen erfolgreich gespeichert.',
        CompanyUsersRegisterLink: 'Firmenbenutzer registrieren Link:',
        LinkCopiedToClipboard: 'Der folgende Link wurde ins Clipboard kopiert: ',
        contactUsIfYouNeedHelp: 'Bitte kontaktieren Sie uns, wenn Sie Hilfe benötigen',
        areYouSureYouWantToDelete: 'Wirklich löschen?',
        cloneLessons: 'Lehren klonen?',
        DataIsClonedFromMsg: 'Daten werden von "AppEx GmbH" geklont',
    },
    introMessages: {
        projectOverViewTradeTabIntroMessage: 'Hier werden phasen-spezifische Arbeitsblätter für die verschiedenen Gewerke erstellt und bearbeitet.',
        projectOverViewPMTabIntroMessage: 'Hier werden phasen-spezifische Arbeitsblätter für Projektmanagement Themen erstellt und bearbeitet.',
        projectOverViewXTabIntroMessage: 'Hier werden %{companyProcessName}-spezifische Arbeitsblätter erstellt und bearbeitet.',
        approvalListPageIntroMessage: 'Alle Lehren welche noch nicht akzeptiert worden sind, werden hier aufgelistet.\n\
        Die Lehren können bearbeitet und akzeptiert oder gelöscht werden.',
        notificationsIntroMessage: 'Notifications intro messages',
        homeHowDoesAppexWork: ' • In jedem Projekt führen Herausforderungen zu Erfahrungen. Einige dieser Erfahrungen eignen sich als Lehren für zukünftige Projekte.<br/>\n\
         • Mitarbeitende dokumentieren diese Erfahrungen und wandeln sie in Lehren um, welche als Fragen formuliert werden. Diese Fragen werden der Projektphase zugeordnet in der sie gestellt werden müssen, um Probleme zu vermeiden.<br/>\n\
         • Mitarbeiter erstellen Arbeitsblätter mit den für ihre Projekte relevanten Fragen aus der Wissensdatenbank. Damit wird sichergestellt, dass Erfahrungen und Lehren in neuen Projekten Anwendung finden, sowohl während der Vorbereitung einer Phase als auch als Qualitätskontrolle zum Phasenabschluss.<br/>\n\
         • Lehren sind nach Gewerken gegliedert oder nach Projektmanagement Thema, falls sie allgemeiner Natur sind oder Prozesscharakter haben.<br/>\n\
         • Phasen, Gewerke, oder Projektmanagement Themen können durch einen Administrator erstellt oder geändert werden.<br/>\n\
         • Mitarbeiter können Projekte erstellen und ihnen Mitarbeiter, Phasen und Gewerke zuordnen. Mitarbeiter können Erfahrungen in ihren Projekten erfassen und als Lehren für die Wissensdatenbank formulieren. Administratoren können diese Lehren anpassen und freigeben.',
        StoreUpdateExperienceIntroMessage: 'Hier können Herausforderungen oder Probleme im Projekt festgehalten werden, die bei Gelegenheit in Lehren für die Wissensdatenbank transferiert werden können.',
        howToConnectToMSTeams: '\n\
        <p>\n\
                    Die Verbindung von AppEx mit Microsoft ermöglicht den Export von Projekten und \n\
                    Arbeitsblättern zu  Teams und Planner.\n\
                </p>\n\
                <ul>\n\
                    <h6><li>Verbindung Herstellen:</li></h6>\n\
                    <ul>\n\
                        <li>Der Microsoft AppEx Administrator wählt Admin -> Integrationen -> Verbinden</li>\n\
                        <ul>\n\
                            <li>Empfehlung: In Microsoft ein Microsoft Admin Konto erstellen, das nur für AppEx gebraucht wird</li>\n\
                        </ul>\n\
                        <li>\n\
                            Auf der Microsoft Bewilligung Seite mit Haken Zustimmung geben und akzeptieren\n\
                        </li>\n\
                        <li>Die Verbindung zu Microsoft wird eingerichtet. (Das ist ein einmaliger Prozess)</li>\n\
                    </ul>\n\
                    <h6><li>Verbindung Aufheben:</li></h6>\n\
                    <ul>\n\
                        <li>Auf Aufheben klicken</li>\n\
                        <li>Aufheben bestätigen</li>\n\
                        <li>Die Verbindung wird automatisch aufgehoben</li>\n\
                        <li><b class="has-text-danger">Für eine Wiederverbindung muss 30 Minuten gewartet werden</b></li>\n\
                    </ul>\n\
                    <h6><li>Bitte Berücksichtigen:</li></h6>\n\
                    <ul>\n\
                        <li>\n\
                            Teams, Projekte, Arbeitsblätter und Aufgaben und alle anderen Funktionen in \n\
                            Microsoft werden im Namen des Microsoft Administrators erstellt, der die \n\
                            Verbindung autorisierte (bei der Namensgebung berücksichtigen).\n\
                        </li>\n\
                        <li>\n\
                            Für Projekte, die mit AppEx verknüpft sind, soll der Microsoft Administrator \n\
                            nicht geändert werden oder die Verbindung aufgehoben werden.\n\
                        </li>\n\
                        <li>Die Erstellung eines Projektes in Teams kann bis zu mehreren Stunden\n\
                            dauern (Statusanzeige beachten, bis 5 Schritte abgeschlossen sind).</li>\n\
                        <li>\n\
                            Die Rechte und Rollen des Microsoft Administrators, der die Verbindung \n\
                            hergestellt hat, sollten nachträglich nicht verändert werden.\n\
                        </li>\n\
                    </ul>\n\
                </ul>\n\
        ',
    },
    emptyMessages: {
        noProjectMessageHeader: 'Noch kein Projekt erstellt',
        noProjectMessageBody: 'Bitte zuerst oben rechts ein Projekt erstellen',
        noLessonMessageHeader: 'Noch kein Lehre erstellt',
        noLessonMessageBody: 'Bitte zuerst eine Lehre hinzufügen ',
        allLessonsAccepted: 'Im Moment sind alle Lehren akzeptiert',
        noExperienceHeader: 'Noch keine Erfahrungen',
        noExperienceBody: 'Oben eine Herausforderung dokumentieren und gegebenenfalls deren mögliche Fragestellung skizzieren (kann später nachgeführt werden.',
        noEntryHeader: 'Keine Einträge gefunden',
        noEntryBody: 'Leider gibt es hier keine Einträge.',
        noTradeOpenTasksHeader: '',
        noTradeOpenTasksBody: 'Diese Person hat keine offenen Aufgaben für die ausgewählten Phasen und Gewerke',
        noPmOpenTasksHeader: '',
        noPmOpenTasksBody: 'Diese Person hat keine offenen Aufgaben für die ausgewählten Phasen',
        noXOpenTasksBody: 'Diese Person hat keine offenen Aufgaben für den ausgewählten %{companyProcessName}',
        msIntegrationHeader: 'Microsoft Integration noch ausstehend',
        msIntegrationBody: 'Während die Microsoft-Integration noch aussteht, können keine Arbeitsblätter erstellt werden',
        projectEditDisabledHeader: 'Project edit disabled for the project "{0}"',
        projectEditDisabledBody: 'If Microsoft connection is revoked project can\'t be edited. Restore Microsoft connection to activate the project',
    },
    confirmRemoveMessages: {
        confirmDelete: 'Bitte geben Sie <span class="has-text-weight-semibold has-text-danger">"{0}"</span> ein, um fortzufahren, oder beenden Sie diesen Modus, um den Vorgang abzubrechen',
        confirmDeleteMicrosoftTeam: 'Microsoft-Team (und alle zugehörigen Ressourcen) im Zusammenhang mit diesem Projekt werden ebenfalls gelöscht.',
        trade: {
            header: 'Sie werden das Gewerk "{0}" entfernen. Entfernte Gewerke können NICHT wiederhergestellt werden! Sind Sie ABSOLUT sicher?',
            body: 'Durch das Entfernen des Gewerkes, werden die Lehren und alle abhängigen Daten einschließlich Arbeitsblättern, angewandte Lehren usw. gelöscht',
        },
        pmPhase: {
            header: 'Sie werden die Phase "{0}" entfernen. Entfernte Phasen können NICHT wiederhergestellt werden! Sind Sie ABSOLUT sicher?',
            body: 'Durch das Entfernen der Phase, werden die Subphasen, Lehren und alle abhängigen Daten einschließlich Arbeitsblättern, angewandte Lehren usw. gelöscht',
        },
        pmSubPhase: {
            header: 'Sie werden die Subphase "{0}" entfernen. Entfernte Subphasen können NICHT wiederhergestellt werden! Sind Sie ABSOLUT sicher?',
            body: 'Durch das Entfernen der Subphase, werden die Lehren und alle abhängigen Daten einschließlich Arbeitsblättern, angewandte Lehren usw. gelöscht',
        },
        xProcess: {
            header: 'Sie werden die X Process "{0}" entfernen. Entfernte X Process können NICHT wiederhergestellt werden! Sind Sie ABSOLUT sicher?',
            body: 'Durch das Entfernen der X Process, werden die X Sub Process, Lehren und alle abhängigen Daten einschließlich Arbeitsblättern, angewandte Lehren usw. gelöscht',
        },
        xSubProcess: {
            header: 'Sie werden die X Sub Process "{0}" entfernen. Entfernte X Sub Process können NICHT wiederhergestellt werden! Sind Sie ABSOLUT sicher?',
            body: 'Durch das Entfernen der X Sub Process, werden die Lehren und alle abhängigen Daten einschließlich Arbeitsblättern, angewandte Lehren usw. gelöscht',
        },
        projectDelete: {
            header: 'Sie werden das Projekt "{0}" entfernen. Entfernte Projekte können NICHT wiederhergestellt werden! Sind Sie ABSOLUT sicher?',
            body: 'Durch das Entfernen vom Projekt, werden die Arbeitsblätter und alle abhängigen Daten einschließlich angewandte Lehren usw. gelöscht',
        },
        projectUpdate: {
            header: 'Sie sind dabei, einige Entitäten aus dem Projekt "{0}" zu entfernen. Entfernte Entitäten KÖNNEN NICHT wiederhergestellt werden! Sind Sie ABSOLUT SICHER?',
            body: 'Liste der zu entfernenden Entitäten:',
        },
        topic: {
            header: 'Sie werden den Themenbereich "{0}" entfernen. Entfernte Themenbereiche können NICHT wiederhergestellt werden! Sind Sie ABSOLUT sicher?',
            body: 'Durch das Entfernen des Themenbereichs werden alle abhängigen Lehren gelöscht',
        },
        phase: {
            header: 'Sie werden die Phase "{0}" entfernen. Entfernte Phasen können NICHT wiederhergestellt werden! Sind Sie ABSOLUT sicher?',
            body: 'Durch das Entfernen der Phase werden alle abhängigen Lehren gelöscht',
        },
        worksheet: {
            header: 'Sie werden das Arbeitsblatt vom Projekt "{0}" entfernen. Entfernte Arbeitsblätter können NICHT wiederhergestellt werden! Sind Sie ABSOLUT sicher?',
            body: 'Alle Einträge werden ebenfalls gelöscht.',
        },
        pmWorksheet: {
            header: 'Sie werden das Arbeitsblatt vom Projekt "{0}" entfernen. Entfernte Arbeitsblätter können NICHT wiederhergestellt werden! Sind Sie ABSOLUT sicher?',
            body: 'Alle Einträge werden ebenfalls gelöscht.',
        },
        users: {
            header: 'Sie werden folgende Benutzer löschen',
            body: 'Alle Daten der ausgewählten Benutzer (Projekte, angewandte Lehren, Lehren, Erfahrungen, Arbeitsblätter und Globale Themen) werden gelöscht, falls sie nicht zu einen anderen Benutzer zugeordnet werden.',
        },
        company: {
            header: 'Sie löschen <span class="has-text-weight-semibold has-text-danger">"{0}"</span> Firma!',
            body: 'Alle Daten (Projekte, angewandte Lehren, Lehren, Erfahrungen, Arbeitsblätter, Globale Themen, Benutzer und so weiter) werden gelöscht!',
        },
        tag: {
            header: 'Sie werden den Tag "{0}" entfernen. Entfernte Tags können NICHT wiederhergestellt werden! Sind Sie ABSOLUT sicher?',
            body: 'Durch das Entfernen des Tags wird er von allen Lehren gelöscht',
        },
    },
    toastMessages: {
        delete: {
            generic: 'Die {x} wurde erfolgreich gelöscht',
            lesson: 'Die Lehre wurde erfolgreich gelöscht',
            trade: 'Die Gewerke wurde erfolgreich gelöscht',
            topic: 'Die Themenbereich wurde erfolgreich gelöscht',
            phase: 'Die Phase wurden erfolgreich gelöscht',
            pmPhase: 'Die Phase wurden erfolgreich gelöscht',
            pmSubPhase: 'Die Subphase wurden erfolgreich gelöscht',
            experience: 'Die Erfahrungen wurden erfolgreich gelöscht',
            worksheet: 'Das Arbeitsblatt wurde erfolgreich gelöscht',
            pmWorksheet: 'Das Arbeitsblatt wurde erfolgreich gelöscht',
            tag: 'Das Tag wurde erfolgreich gelöscht',
        },
        store: {
            generic: 'Die {x} wurde erfolgreich gespeichert',
            lesson: 'Die Lehre wurde erfolgreich gespeichert',
            trade: 'Das Gewerk wurde erfolgreich gespeichert',
            topic: 'Der Themenbereich wurde erfolgreich gespeichert',
            phase: 'Die Phase wurde erfolgreich gespeichert',
            pmPhase: 'Die Phase wurde erfolgreich gespeichert',
            pmSubPhase: 'Die Subphase wurde erfolgreich gespeichert',
            dynamicField: 'Das Attribut wurde erfolgreich gespeichert',
            worksheet: 'Das Arbeitsblatt wurde erfolgreich gespeichert',
            experience: 'Die Lehre wurde erfolgreich gespeichert und aus den Erfahrungen gelöscht',
            cloningSuccessful: 'Die Daten wurden korrekt übertragen',
            email: 'Das Email wurde erfolgreich versendet',
            tag: 'Das Tag wurde erfolgreich gespeichert',
        },
        update: {
            generic: 'Das {x} wurde erfolgreich aktualisiert',
            account: 'Das Konto wurde erfolgreich aktualisiert',
            lesson: 'Die Lehre wurde erfolgreich aktualisiert',
            trade: 'Das Gewerk wurde erfolgreich aktualisiert',
            topic: 'Der Themenbereich wurde erfolgreich aktualisiert',
            phase: 'Die Phase wurde erfolgreich aktualisiert',
            pmPhase: 'Die Phase wurde erfolgreich aktualisiert',
            pmSubPhase: 'Die Projektmanagement Subphase wurde erfolgreich aktualisiert',
            dynamicField: 'Das Attribut wurde erfolgreich aktualisiert',
            worksheet: 'Das Arbeitsblatt wurde erfolgreich aktualisiert',
            tag: 'Das Tag wurde erfolgreich aktualisiert',
            emailedOpenTasks: 'E-Mails erfolgreich verschickt',
        },
        error: {
            worksheet: 'Das Arbeitsblatt konnte nicht aktualisiert werden',
            cannot_load_appliedLessons: 'Die Lehre konnten nicht geladen werden',
            cannot_remove_worksheet: 'Das Arbeitsblatt konnte nicht gelöscht werden.',
            cloningError: 'Die Daten konnten leider nicht geklont werden',
            lesson: 'Could not remove the Lesson.',
            error: 'Ein Fehler ist aufgetreten',
        },
    },
    navigation: {
        switcher: {
            changeTo: 'Wechseln zu',
            native: {
                name: 'AppEx',
                description: 'Wissen und Projekte',
            },
            orders: {
                name: 'Bestellungen',
                description: 'Verwalte Lieferobjekte',
            },
            loading: 'Öffnen',
        },
        main: {
            objects: 'Meine Projekte',
            reports: 'Zu Tun',
            experiences: 'Meine Erfahrungen',
            approval: 'Neues Wissen',
            notifications: 'Mitteilungen',
            setup: 'Wissen',
            system: 'Admin',
            register: 'Registrieren',
            login: 'Anmelden',
            logout: 'Abmelden',
        },
    },
    notificationMessages: {
        applied_lesson_stored: 'hat eine Frage zum Arbeitsblatt von Gewerk: <b>{0}</b> und Phase: <b>{1}</b> hinzugefügt',
        pm_applied_lesson_stored: 'hat eine Frage zu <b>{0}</b> hinzugefügt',
        x_applied_lesson_stored: 'hat eine Frage zu <b>{0}</b> hinzugefügt',
        project_stored: 'hat Projekt <b>{0}</b> erstellt',
        project_updated: 'hat Projekt <b>{0}</b> bearbeitet',
        project_deleted: 'hat Projekt <b>{0}</b> gelöscht',
        worksheet_stored: 'erstellte ein Arbeitsblatt für Gewerk: <b>{0}</b> und Phase: <b>{1}</b>',
        worksheet_edited: 'bearbeitet ein Arbeitsblatt für Gewerk: <b>{0}</b> und Phase: <b>{1}</b>',
        worksheet_deleted: 'hat ein Arbeitsblatt für Gewerk: <b>{0}</b> und Phase: <b>{1}</b> gelöscht',
        pm_worksheet_stored: 'hat PM Arbeitsblatt <b>{0}</b> erstellt',
        pm_worksheet_edited: 'hat PM Arbeitsblatt <b>{0}</b> bearbeitet',
        pm_worksheet_deleted: 'hat PM Arbeitsblatt <b>{0}</b> gelöscht',
    },
    integrations: {
        introduction: 'Integrationen ermöglichen es Ihnen, Anwendungen von Drittanbietern zu einem Teil Ihres AppEx-Workflows zu machen.',
    },
    orders: {
        title: 'Bestellung',
        phases: 'PM Phasen',
        deliveryObjectCompletionPercentage: 'Lieferobjekte %',
        bimTargetCompletionPercentage: 'BIM-Ziele %',
        bimUseCaseCompletionPercentage: 'BIM-Anwendungsfälle %',
        link: 'Link',
    },
};

export default de;